import createTheme from '@mui/material/styles/createTheme';

const theme = createTheme({
  palette: {
    primary: {
      main: '#808080',
    },
    secondary: {
      main: '#FE5000',
    },
    error: {
      main: '#ff0000',
    },
    success: {
      main: '#009245',
    },
    warning: {
      main: '#FFB60A',
    },
    info: {
      main: '#4163fa',
    },
    light: {
      main: '#fdefe9',
    },
    primaryBrand: {
      main: '#3F2A56',
    },
    dropzoneBorder: {
      main: '#ced4da',
    },
    dropzoneBackgroundColor: {
      main: '#f8f9fa',
    },
    submitButtonBackgroundColor: {
      main: '#01B0BB',
      hover: '#81B0BB',
    },
    tagColor: {
      textColor: {
        DEFAULT: '#595959',
        DRY: '#956E3F',
        FROZEN: '#447A97',
        REFRIGERATED: '#324CAF',
      },
      backgroundColor: {
        DEFAULT: '#F3F3F3',
        DRY: '#FDF6EC',
        FROZEN: '#EEFAFE',
        REFRIGERATED: '#F1F7FE',
      },
    },
  },
  drawer: {
    width: 240,
  },
  typography: {
    fontFamily: 'rubik, sans-serif;',
    subtitle1: {
      fontWeight: 600,
    },
    caption: {
      color: '#656565',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 30,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          borderWidth: 3,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #d5d0da',
        },
      },
    },
  },
});

export default theme;
